import { render } from "./permissions-page.vue?vue&type=template&id=00c173e6"
import script from "./permissions-page.ts?vue&type=script&lang=js"
export * from "./permissions-page.ts?vue&type=script&lang=js"

import "./permissions-page.scss?vue&type=style&index=0&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__